module.exports = __webpack_public_path__ + "img/2.6e68f21a.png";